import api from "@api";

import {log} from "@helpers";

const cancelarPlano = async (setCurrentProgress) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  if (!currentUser) return;
  const payload = {
    pathWithDomain: `${process.env.REACT_APP_API_V2}/api/v1/forma_pagamento/suspend_subscription`,
    method: "POST",
  };
  log("POST cancelarPlano:", payload);

  return api(payload, setCurrentProgress);
};

export default cancelarPlano;
